import React, { useState } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PlanCard } from './PlanCard';
import { SpotsCounter } from './SpotsCounter';
import { UrgencyBar } from './UrgencyBar';
import { plans } from '../data/plans';
import { HERO_IMAGE } from '../data/images';
export function OrderBox() {
  const [selectedPlan, setSelectedPlan] = useState<'starter' | 'complete'>('complete');
  const starter = plans[0];
  const complete = plans[1];
  return <div className="order-box" data-id="element-25" data-mp="2wcmtvkc6lmx0">
      <div className="flex flex-col items-center text-center" data-id="element-26" data-mp="319dac8rwekiy">
        <img src={HERO_IMAGE} alt="The Positive Parenting Mega Kit box filled with printable routine charts" width={1063} height={1500} loading="lazy" decoding="async" className="block h-auto w-full max-w-[294px]" style={{
        aspectRatio: '1063 / 1500',
        filter: 'drop-shadow(0 12px 16px rgba(20,17,15,0.16))'
      }} data-id="element-27" data-mp="31bpmu6ew02om" />

        <h2 className="mt-5 text-[26px] font-extrabold leading-[1.15] md:text-[34px]" data-id="element-28" data-mp="3129u0fezgsfr">
          <span className="block" data-id="element-29" data-mp="2w3f6x19zghpu">The Calm Mornings</span>
          <span className="block" data-id="element-30" data-mp="2w3yg9tlkhxs9">Mega Kit</span>
        </h2>

        <p className="mt-3 text-[12px] font-medium uppercase tracking-[0.14em] text-ink/55" data-id="element-31" data-mp="2s1252nycx3yc">
          +13,369 downloads by mindful families
        </p>
      </div>

      <div role="radiogroup" aria-label="Choose your plan" className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 md:items-start md:gap-4" data-id="element-32" data-mp="2n5384byyqdmb">
        <div className="order-2 md:order-1" data-id="element-33" data-mp="2dbdzvbn21l5c">
          <PlanCard plan={starter} selected={selectedPlan === 'starter'} onSelect={() => setSelectedPlan('starter')} data-id="element-34" data-mp="28dkx6skyn99t" />
        </div>
        <div className="order-1 md:order-2" data-id="element-35" data-mp="24afy70039ppx">
          <PlanCard plan={complete} recommended selected={selectedPlan === 'complete'} onSelect={() => setSelectedPlan('complete')} data-id="element-36" data-mp="1zc4mejq8h552" />
        </div>
      </div>

      <div className="mt-6" data-id="element-37" data-mp="1kpnze8o6zv9c">
        <SpotsCounter data-id="element-38" data-mp="1kstss03utjav" />
      </div>

      <div className="mt-6" data-id="element-39" data-mp="1pq3g9a7onkw2">
        <UrgencyBar data-id="element-40" data-mp="1pqbv37nd909w" />
      </div>

      <div className="mt-4 text-center" data-id="element-41" data-mp="1pn7h5ik3mq61">
        <p className="flex items-center justify-center gap-1.5 text-[13px] text-ink/70" data-id="element-42" data-mp="1at2zg1r15acd">
          <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 flex-none" data-id="element-43" data-mp="1fquo8mwdogcc" />
          Instant access by email · Secure payment
        </p>
        <p className="mt-0.5 text-[12px] text-ink/55" data-id="element-44" data-mp="23hgt65b35ki4">
          100% digital — nothing will be shipped
        </p>
      </div>
    </div>;
}